import { render, staticRenderFns } from "./OzPopoverModal.vue?vue&type=template&id=2815c7b2&"
import script from "./OzPopoverModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzPopoverModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports